import React from "react";
import App from "./App";
import './index.css';
import { DarkModeContextProvider } from "./context/darkModeContext";
import { createRoot } from 'react-dom';

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <DarkModeContextProvider>
      <App />
    </DarkModeContextProvider>
  </React.StrictMode>
);

